export default "__VITE_ASSET__2rhw0eZZ__"